import { FC } from 'react'

import styled from 'styled-components'

import { colors, device } from 'src/Helpers/constants.ts'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  gap: 10px;
  padding: 10px;
  width: 100%;

  @media ${device.tabletMax} {
    display: none;
  }
`

const ParametersContainer = styled.div`
  display: grid;
  grid-column-gap: 16px;
  grid-template-columns: 0.6fr 0.4fr 0.4fr 0.4fr 0.6fr 1fr;
  width: 100%;
`

const Parameter = styled.div`
  font-size: 12px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: ${colors.thirdGray};
  font-weight: 600;
  justify-content: flex-start;
`

const NameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  width: 250px;
`

const MenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  button {
    margin-left: auto;
  }
`

export const TableHeader: FC = () => {
  return (
    <Container>
      <ParametersContainer>
        <NameWrapper>
          <Parameter>Наименование клиента</Parameter>
        </NameWrapper>
        <Parameter>Номер</Parameter>
        <Parameter>Дата заключения</Parameter>
        <Parameter>Статус согласования</Parameter>
        <Parameter>Комментарий</Parameter>
        <MenuWrapper></MenuWrapper>
      </ParametersContainer>
    </Container>
  )
}
